import { callApi } from './api'
import * as qs from 'utils/querystring'

export function check (requestParameters) {
  const { code, estimatedHours, serviceTypeId, aliadaId } = requestParameters
  const endpoint = 'promotional_codes/check'
  const querystring = qs.stringify({
    promotionalCode: code,
    estimatedHours,
    serviceTypeId,
    aliadaId
  })
  const endpointWithQuerystring = endpoint + querystring

  const config = { requiresAuth: true }

  return callApi(endpointWithQuerystring, config)
}



// WEBPACK FOOTER //
// ./src/services/api/promotional-code.js